import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { PermissionCodeEnum } from '/@/enums/permissionCodeEnum';
import { STORAGE_KEY } from '/@/constants/storage';

const dataset: AppRouteModule = {
  path: RouteEnum.ONTOLOGY,
  name: RouteEnum.ONTOLOGY,
  component: LAYOUT,
  redirect: RouteEnum.ONTOLOGY_CENTER,
  meta: {
    hideChildrenInMenu: true,
    icon: 'ontology|svg',
    title: t('routes.ontology.ontology'),
    orderNo: 10,
    // hideMenu: true,
    permCode: [PermissionCodeEnum.ONTOLOGY_ONTOLOGY_QUERY],
  },
  children: [
    {
      path: 'center',
      name: RouteEnum.ONTOLOGY_CENTER,
      component: () => import('/@/views/ontology/center/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
    {
      path: 'class',
      name: RouteEnum.ONTOLOGY_CLASS,
      component: () => import('/@/views/ontology/classes/index.vue'),
      meta: {
        title: t('routes.ontology.class'),
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.ONTOLOGY_CENTER,
      },
    },
    {
      path: 'classification',
      name: RouteEnum.ONTOLOGY_CLASSIFICATION,
      component: () => import('/@/views/ontology/classes/index.vue'),
      meta: {
        title: t('routes.ontology.classification'),
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.ONTOLOGY_CENTER,
      },
    },
  ],
};

export default dataset;
